import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { RocketIcon } from 'lucide-react';
export function OfferBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const handleClick = () => {
    const el = document.getElementById('pricing');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-191">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 28
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-[#0a0a14]/95 backdrop-blur-md border-t border-brand-orange/40 shadow-[0_-8px_30px_rgba(249,115,22,0.25)]" data-id="element-192">
          <div className="max-w-3xl mx-auto px-3 sm:px-4 py-3 sm:py-4 flex items-center justify-between gap-2 sm:gap-3" data-id="element-193">
            <div className="flex flex-col leading-tight shrink-0" data-id="element-194">
              <span className="text-[9px] sm:text-xs font-black uppercase tracking-widest text-brand-cream/80" data-id="element-195">
                Sistema Domotica Pro
              </span>
              <span className="text-xl sm:text-3xl font-black text-brand-orange" data-id="element-196">
                €27,90
              </span>
            </div>
            <button onClick={handleClick} className="flex-1 inline-flex items-center justify-center gap-2 bg-gradient-to-r from-brand-orange to-brand-amber text-white font-black uppercase text-xs sm:text-base px-3 sm:px-6 py-3 sm:py-4 rounded-xl shadow-[0_0_20px_rgba(249,115,22,0.5)] hover:scale-[1.02] transition-transform" data-id="element-197">
              <RocketIcon className="w-4 h-4 sm:w-5 sm:h-5 shrink-0" data-id="element-198" />
              <span className="truncate" data-id="element-199">ACCEDI ORA</span>
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}